// extracted by mini-css-extract-plugin
export var localeSelector = "_b3-0";